import serverApi from './serverAPIConfig'

export default {
    ...serverApi,
    skipDataMigrators: true,
    skipBuilderSchemaValidation: true
}
